












export default {
  props: {
    initialValue: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
  },
  data() {
    return {
      initialized: false,
      value: '',
      v2: '',
    }
  },
  computed: {
    modified(): boolean {
      let m = this.checkIfModified()
      return m
    },
  },

  mounted() {
    this.value = this.initialValue
    setTimeout(() => {
      this.value = this.initialValue
      this.initialized = true
    }, 1000)
  },
  methods: {
    checkIfModified(): boolean {
      if (!this.initialized) {
        return false
      }
      let floatVal = parseFloat('' + this.value)
      let floatInit = parseFloat('' + this.initialValue)
      if (isNaN(floatVal)) {
        floatVal = 0
      }
      if (isNaN(floatInit)) {
        floatInit = 0
      }
      let m = '' + floatVal !== '' + floatInit
      return m
    },
    undo() {
      this.value = this.initialValue
    },
  },
}
